import { render, staticRenderFns } from "./BaseDrawerLeft.vue?vue&type=template&id=5d1f5d54&"
import script from "./BaseDrawerLeft.vue?vue&type=script&lang=js&"
export * from "./BaseDrawerLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports